module.exports = __webpack_public_path__ + "static/media/background-third-row.b6fe81fe.png";